import { createReducer, isAnyOf } from '@reduxjs/toolkit';
import { websocketActions } from 'middleware/websocket/actions/websocket';
import { appActions } from './app.actions';
const initialState = {
    modals: [],
    asyncStatus: {
        app: 'uninitialized',
        featureFlags: 'uninitialized',
        presence: 'uninitialized',
    },
    conversationTransferRequests: [],
    organizations: [],
};
export const appReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(appActions.logIn, (state, action) => {
        state.logInType = action.payload.type;
    })
        .addCase(appActions.setError, (state, action) => {
        state.error = action.payload.error;
    })
        .addCase(appActions.showModal.action, (state, action) => {
        const modal = action.payload.modal;
        if (state.modals.every(({ type }) => type !== modal.type)) {
            state.modals = [modal, ...state.modals];
        }
    })
        .addCase(appActions.hideModal, (state, action) => {
        state.modals = state.modals.filter((modal) => modal.type !== action.payload.type);
    })
        .addCase(appActions.conversationTransferRequest.pending, (state, action) => {
        state.conversationTransferRequests.push(action.payload);
    })
        .addCase(appActions.conversationTransferRequest.fulfilled, (state, action) => {
        const { type, csid } = action.payload.response.params;
        state.conversationTransferRequests =
            state.conversationTransferRequests.filter(({ request }) => request.csid !== csid && request.type !== type);
    })
        .addCase(appActions.conversationTransferRequest.rejected, (state, action) => {
        const { csid, type } = action.payload.error;
        state.conversationTransferRequests =
            state.conversationTransferRequests.filter(({ request }) => request.csid !== csid && request.type !== type);
    })
        .addCase(appActions.conversationTransferClear, (state, action) => {
        const { csid } = action.payload;
        state.conversationTransferRequests =
            state.conversationTransferRequests.filter((transfer) => transfer.request.csid !== csid);
    })
        .addCase(appActions.setOrganizations, (state, action) => {
        state.organizations = action.payload.organizations;
    })
        .addCase(appActions.setOrganization, (state, action) => {
        state.organization = action.payload.organization;
    })
        .addMatcher(isAnyOf(appActions.getFeatureFlags.pending, appActions.getFeatureFlags.fulfilled, appActions.getFeatureFlags.rejected), (state, action) => {
        state.asyncStatus.featureFlags = action.meta.requestStatus;
    })
        .addMatcher(isAnyOf(appActions.getPresence.pending, appActions.getPresence.fulfilled, appActions.getPresence.rejected), (state, action) => {
        state.asyncStatus.presence = action.meta.requestStatus;
    })
        .addMatcher(isAnyOf(websocketActions.create, appActions.getFeatureFlags.pending, appActions.getPresence.pending), (state) => {
        if (state.asyncStatus.app !== 'fulfilled') {
            state.asyncStatus.app = 'pending';
        }
    })
        .addMatcher(isAnyOf(websocketActions.createRejected, appActions.getFeatureFlags.rejected, appActions.getPresence.rejected), (state) => {
        if (state.asyncStatus.app !== 'fulfilled') {
            state.asyncStatus.app = 'rejected';
        }
    })
        .addMatcher(isAnyOf(
    // We don't check that WebSocket is fulfilled as these actions only fire
    // when the WebSocket has been fulfilled.
    appActions.getFeatureFlags.fulfilled, appActions.getPresence.fulfilled), (state) => {
        if (state.asyncStatus.presence === 'fulfilled' &&
            state.asyncStatus.featureFlags === 'fulfilled') {
            state.asyncStatus.app = 'fulfilled';
        }
    });
});
